(function () {
    'use strict';

    angular
        .module('app')
        .controller('WorkflowRunCtrl', WorkflowRunCtrl);

    WorkflowRunCtrl.$inject = [
        '$scope',
        '$routeParams',
        '$q',
        'EntityTemplatesService',
        'WorkflowInstanceDataService',
        'WorkflowRunService',
        'DialogService',
        'LastUpdatedService',
        'NavigationAidService',
        'WindowTitleService',
        'ItemService'];

    function WorkflowRunCtrl(
        $scope,
        $routeParams,
        $q,
        EntityTemplatesService,
        WorkflowInstanceDataService,
        WorkflowRunService,
        DialogService,
        LastUpdatedService,
        NavigationAidService,
        WindowTitleService,
        ItemService) {

        /* jshint validthis:true */
        var vm = this;
        vm.workflowInstanceData = null;
        vm.itemCount = 0;
        vm.currentTabPage = 'input';
        vm.startWorkflow = startWorkflow;
        vm.cancelWorkflow = cancelWorkflow;
        vm.close = close;
        Object.defineProperty(vm, 'viewTitle', { get: function () { return 'Run Workflow - ' + ((!_.isNil(vm.workflowInstanceData) && !_.isNil(vm.workflowInstanceData.Name)) ? vm.workflowInstanceData.Name : ''); } });
        Object.defineProperty(vm, 'lastUpdatedLabel', {
            get: function () { return LastUpdatedService.getWorkflowInstanceLabel(vm.workflowInstanceData); }
        });
        Object.defineProperty(vm, 'workflowProgress', {
            get: getWorkflowProgress
        });
        Object.defineProperty(vm, 'workflowStatus', {
            get: getWorkflowStatus
        });
        Object.defineProperty(vm, 'waitingStep', {
            get: function () {
                if (vm.workflowInstanceData === null || angular.isUndefined(vm.workflowInstanceData.Stack) || vm.workflowInstanceData.Stack === null) {
                    return null;
                } else {
                    return _.find(vm.workflowInstanceData.Stack, { Properties: { ActivityFlag: 'Waiting' } });
                }
            }
        });
        Object.defineProperty(vm, 'runningStep', {
            get: function () {
                if (vm.workflowInstanceData === null || angular.isUndefined(vm.workflowInstanceData.Stack) || vm.workflowInstanceData.Stack === null) {
                    return null;
                } else {
                    return _.find(vm.workflowInstanceData.Stack, { Properties: { ActivityFlag: 'Processing' } });
                }
            }
        });
        vm.loading = true;
        vm.notFound = false;
        vm.itemListApi = {};
        vm.itemListUpdated = itemListUpdated;

        activate();

        function activate() {
            WindowTitleService.setTitle('Run Workflow');

            NavigationAidService.watchTabPage($scope, 'vm.currentTabPage');

            WorkflowRunService.onEvent($scope, 'workflow:workflowStepStarted', function (event, workflowId, step) {
                if (workflowId === vm.workflowInstanceData.Id) {
                    if (step.Properties.ActivityFlag === 'Waiting') {
                        onStepWaiting();
                    }

                    $scope.$apply(function () {
                        vm.workflowInstanceData.Stack.push(step);
                    });
                }
            });

            WorkflowRunService.onEvent($scope, 'workflow:workflowStepUpdated', function (event, workflowId, step) {
                if (workflowId === vm.workflowInstanceData.Id) {
                    $scope.$apply(function () {
                        updateStepInViewModel(step);
                    });
                }
            });

            WorkflowRunService.onEvent($scope, 'workflow:workflowStatusChange', function (event, workflowId, workflowName, workflowStatus) {
                if (workflowId === vm.workflowInstanceData.Id) {
                    vm.workflowInstanceData.Status = workflowStatus;
                }
            });

            var loadPromises = [];
            loadPromises.push(loadUserEntityTemplateName());
            loadPromises.push(loadWorkflowInstance());

            $q.all(loadPromises)
                .then(function () {
                    WindowTitleService.setTitle('Run Workflow - ' + vm.workflowInstanceData.Name);

                    $scope.$watch('vm.workflowInstanceData.Status', function (newStatus, oldStatus) {
                        if (newStatus !== oldStatus && newStatus === 'Completed') {
                            vm.itemListApi.refresh();
                        }
                    });

                    if (vm.workflowInstanceData.Status === 'NotStarted') {
                        vm.startWorkflow();
                    }
                }).finally(function () {
                    vm.loading = false;

                    var currentTabFromHistory = NavigationAidService.getCurrentTabPage();
                    if (!_.isNil(currentTabFromHistory)) {
                        // Load tab page from history
                        vm.currentTabPage = currentTabFromHistory;
                    }
                });
        }

        function updateStepInViewModel(step) {
            var index = _.findLastIndex(vm.workflowInstanceData.Stack, { StepId: step.StepId });
            if (index !== -1) {
                if (step.Properties.ActivityFlag === 'Waiting' && vm.workflowInstanceData.Stack[index].Properties.ActivityFlag !== 'Waiting') {
                    onStepWaiting();
                }

                vm.workflowInstanceData.Stack.splice(index, 1, step);
            }
        }

        function onStepWaiting() {
            // When a step enters the "Waiting" state, refresh the item list
            vm.itemListApi.refresh();
        }

        function itemListUpdated() {
            ItemService.getItemsByParent(vm.workflowInstanceData.Id, {
                pageNumber: 1,
                pageSize: 0,
                recordType: ['Email', 'File', 'Note', 'SMS', 'Task']
            }).then(getItemCountOk);

            function getItemCountOk(data) {
                vm.itemCount = data.ItemCount;
            }
        }

        function loadWorkflowInstance() {
            return WorkflowInstanceDataService.get($routeParams.id)
                .then(loadWorkflowInstanceOk, loadWorkflowInstanceError);

            function loadWorkflowInstanceOk(data) {
                vm.workflowInstanceData = data;
            }

            function loadWorkflowInstanceError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error loading Workflow instance data', response);
                }

                return $q.reject(response);
            }
        }

        function loadUserEntityTemplateName() {
            EntityTemplatesService.query({ EntityType: 'User' })
                .then(getUserEntityTemplateOk, getUserEntityTemplateError);

            function getUserEntityTemplateOk(data) {
                if (!_.isNil(data) && !_.isNil(data.EntityTemplates) && data.EntityTemplates.length > 0 && !_.isNil(data.EntityTemplates[0])) {
                    vm.userEntityTemplateName = data.EntityTemplates[0].Name;
                }
            }

            function getUserEntityTemplateError(response) {
                return DialogService.error('Error retrieving User Entity Template', response);
            }
        }

        function startWorkflow() {
            vm.workflowInstanceData.Status = 'Started';

            return WorkflowRunService.start(vm.workflowInstanceData.Id).catch(function (response) {
                vm.workflowInstanceData.Status = 'Error';
                DialogService.error('Error starting Workflow', response);
                return $q.reject(response);
            });
        }

        function cancelWorkflow() {
            return WorkflowRunService.cancel(vm.workflowInstanceData.Id).catch(function (response) {
                DialogService.error('Error cancelling Workflow', response);
                return $q.reject(response);
            });
        }

        /**
         * Get the progress of the current workflow as a percentage
         *
         * @returns {number} - Percentage of the current workflow that has ran.
         */
        function getWorkflowProgress() {
            var progress = 0;

            if (!_.isNil(vm.workflowInstanceData)) {
                if (vm.workflowInstanceData.Status === 'Completed') {
                    progress = 100;
                } else {
                    var nonLinkStepsCount = (_.filter(vm.workflowInstanceData.Steps, function (step) { return step.StepType !== 'Link'; })).length;
                    var completedStepCount = (_.filter(vm.workflowInstanceData.Stack, function (step) { return !_.isNil(step.FinishedDate); })).length;
                    progress = (100 / nonLinkStepsCount) * completedStepCount;
                }
            }

            return progress;
        }

        /**
         * Get the status of the current workflow
         *
         * @returns {string} - Status of the workflow
         */
        function getWorkflowStatus() {
            var status = '';

            switch (vm.workflowInstanceData.Status) {
                case 'NotStarted':
                    status = 'Not started';
                    break;
                case 'Started':
                    var stepName = null;
                    if (!_.isNil(vm.waitingStep)) {
                        stepName = vm.waitingStep.Name;
                    } else if (!_.isNil(vm.runningStep)) {
                        stepName = vm.runningStep.Name;
                    }

                    status = 'Running ' + (stepName ? '"' + stepName + '" ' : '') + '...';
                    break;
                case 'Idle':
                    status = 'Idle';
                    break;
                case 'Cancelled':
                    status = 'Cancelled';
                    break;
                case 'Completed':
                    status = "Completed";
                    break;
            }
            
            return status;
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();